class AvailableCountries extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button[type="button"]');
    this.panel = this.querySelector('ul');

    this.button.addEventListener('click', (event) => this.open(event));

    // this.querySelectorAll('a').forEach((item) =>
    //   item.addEventListener('click', (event) => this.onItemClick(event))
    // );
  }
  // Close the localization form when clicking outside
  closeClickOutside = (event) => {
    if (!this.querySelector('ul').contains(event.target)) {
      this.close();
    }
  };

  // Close the localization form when clicking the escape key
  closeOnEscape = (event) => {
    if (event.key === 'Escape') {
      this.close();
    }
  };

  onItemClick(event) {
    setTimeout(() => this.close(), 300);
  }

  open(event) {
    event.preventDefault();
    event.stopPropagation();

    this.button.setAttribute('aria-expanded', 'true');

    document.addEventListener('click', this.closeClickOutside);
    document.addEventListener('keydown', this.closeOnEscape);

    // Opening animation
    this.panel.classList.remove('invisible', 'opacity-0', 'translate-y-[-10px]');
    this.panel.classList.add('opacity-100', 'translate-y-0');
  }

  close() {
    this.button.removeAttribute('aria-expanded');

    document.removeEventListener('click', this.closeClickOutside);
    document.removeEventListener('keydown', this.closeOnEscape);

    // Closing animation
    this.panel.classList.remove('opacity-100', 'translate-y-0');
    this.panel.classList.add('opacity-0', 'translate-y-[-10px]');

    const handleTransitionEnd = () => {
      this.panel.classList.add('invisible');
      this.panel.removeEventListener('transitionend', handleTransitionEnd);
    };
    this.panel.addEventListener('transitionend', handleTransitionEnd);
  }
}

customElements.define('available-countries', AvailableCountries);
